<template>
	<div>
		<h3 class="text-center">Total query (last 6 hours): <b>{{totals}}</b></h3>
		<div class="row">
			<div class="col-6"></div>
			<div class="col-6">
				<div class="float-right">
					<div class="form-group">
						<select class="form-control-sm" id="period" v-model="periodDNS" @change="fetchDNSData('true')">
							<option value="30">Last 30 minutes</option>
							<option value="360">Last 6 hours</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<canvas id="myChart" style="width: 100% !important;height: 450px !important;"></canvas>
	</div>
</template>


<script>
	import moment from 'moment';
	import Chart from 'chart.js';

	export default {
		name: "DNS",
		props: ['account'],
		data: function () {
			return {
				periodDNS: 360,
				totals: 0,
			}
		},
		watch: {
			account() {
				this.fetchDNSData();
			}
		},
		methods: {
			fetchDNSData() {
				if (
					this.account.cloudflare.apiKey == 'NA' ||
					this.account.cloudflare.username == 'NA' ||
					!this.account.cloudflare.apiKey ||
					!this.account.cloudflare.username ||
					this.account.cloudflare.zone_id === undefined
				) {
					return false;
				}
				this.$http.post('analytics/dns', {
					'cloudflare_email': this.account.cloudflare.username,
					'cloudflare_api_key': this.account.cloudflare.apiKey,
					'cloudflare_zone': this.account.cloudflare.zone_id,
					'domain': this.account.domain,
					'filter': {
						'since': moment().subtract(this.periodDNS, 'minute').utc().format(),
						'until': moment().utc().format(),
						'time_delta': 'minute'
					}
				}, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
					.then((res) => {
						let intervals = [];

						let data = res.data.data;

						if (data.data) {
							this.totals = data.totals.queryCount;

							let metrics = data.data[0].metrics[0];
							let time_intervals = data.time_intervals;

							if (metrics.length) {
								metrics.map((item, index) => {
									intervals.push({
										t: moment(time_intervals[index][0]),
										y: item
									})
								});
							}
							this.dataCollection = {
								datasets: [
									{
										label: 'No Error',
										backgroundColor: '#f87979',
										borderWidth: 1,
										showLine: true,
										data: intervals
									}
								]
							};
							let ctx = document.getElementById('myChart');
							new Chart(ctx, {
								type: 'line',
								data: this.dataCollection,
								options: {
									scales: {
										xAxes: [{
											type: 'time',
											distribution: 'series',
											time: {
												parser: 'MM/DD/YYYY HH:mm',
												//unit: 'hour',
												displayFormats: {
													quarter: 'HH:mm'
												},
												stepSize: 50
											},
											ticks: {
												source: 'data',
												autoSkip: true
											},
											scaleLabel: {
												display: true,
												labelString: 'Time (local)'
											}
										}],
										yAxes: [{
											scaleLabel: {
												display: true,
												labelString: 'Number of Queries'
											}
										}]
									}
								}
							});
						}
					})
			},
		},
		mounted() {
			this.fetchDNSData();
		}
	};
</script>
